<template>
  <div>
    <SwappingSquaresSpinner v-if="this.$store.getters.isLoading"
      :animation-duration="1000"
      :size="90"
      :color="this.$store.getters.config.palette.primary"
      style="margin: 30px auto;"
    />
    <form v-if="!this.$store.getters.isLoading" @submit.prevent="onsubmit">
      <va-input
        v-model="email"
        type="email"
        :label="$t('auth.email')"
        :error="!!emailErrors.length"
        :error-messages="emailErrors"
      />

      <va-input
        v-model="password"
        type="password"
        :label="$t('auth.password')"
        :error="!!passwordErrors.length"
        :error-messages="passwordErrors"
      />
      <div class="d-flex justify--center mt-3">
        <va-button type="submit" class="my-0" style="background-image: unset; background-color: rgb(108, 127, 238); box-shadow: rgb(10 13 117 / 25%) 0 1px 1px 0;">{{ $t('auth.login') }}</va-button>
      </div>
    </form>
    <div class="auth-options auth-layout__options d-flex align--center justify--space-between">
      <!--        <va-checkbox v-model="keepLoggedIn" class="mb-0" :label="$t('auth.keepLoggedIn')"/>-->
      <div class="ml-1 link" @click="googleAuthorization">
        <div class="google-btn">
          <div class="google-icon-wrapper">
            <img class="google-icon-svg" src="../../../assets/icons/google_logo.svg" />
          </div>
          <p class="btn-text"><b>{{$t('auth.googleBtn')}}</b></p>
        </div>
      </div>
      <router-link class="ml-1 link" :to="{name: 'recover-password'}">
        <va-icon
          name="fa fa-refresh"
        />
        {{$t('auth.recoverPassword')}}
      </router-link>
    </div>
  </div>
</template>

<script>
import { SwappingSquaresSpinner } from 'epic-spinners'
import errorHandlerMixin from '@/mixin/errorHandlerMixin'
import clientSignal from '@/mixin/clientSignal'

export default {
  components: { SwappingSquaresSpinner },
  mixins: [errorHandlerMixin, clientSignal],
  name: 'login',
  data () {
    return {
      email: '',
      password: '',
      keepLoggedIn: false,
      emailErrors: [],
      passwordErrors: [],
    }
  },
  computed: {
    formReady () {
      return !this.emailErrors.length && !this.passwordErrors.length
    },
  },
  methods: {
    async googleAuthorization () {
      const authCode = await this.$gAuth.getAuthCode()
      // await this.$gAuth.signIn()
      this.$store.commit('setLoading', true)
      this.$store.dispatch('loginGoogle', {
        socialToken: authCode,
        accessToken: 'authCode.wc.access_token',
        expiresIn: 2223,
        platform: 'google',
        refreshToken: 'no_refresh_token_dummy',
      }).then(() => {
        this.makeSignalRConnection()
        this.$router.push({ name: 'dashboard' })
      }).catch((error) => this.errorHandler(error.response))
    },
    getUserData () {},
    onLogout () {},
    onsubmit () {
      this.emailErrors = this.email ? [] : [this.$t('auth.emailError')]
      this.passwordErrors = this.password ? [] : [this.$t('auth.passwordError')]
      if (!this.formReady) {
        return
      }
      this.$store.commit('setLoading', true)
      this.$store.dispatch('login', {
        email: this.email,
        password: this.password,
      }).then(() => {
        this.makeSignalRConnection()
        this.$router.push({ name: 'dashboard' })
      })
        .catch(error => {
          if (error) {
            this.errorHandler(error.response)
          }
        })
    },
  },
}
</script>

<style lang="scss">
  .auth-options {
    margin-bottom: -24px;
    margin-top: 20px;
  }

  .google-btn {
    margin: 25px;
    width: 80%;
    min-width: 184px;
    max-width: 184px;
    height: 42px;
    background-color: #fcfcfc;
    border-radius: 2px;
    box-shadow: 0 3px 4px 0 rgba(0, 0, 0, 0.2);
    cursor: pointer;
    cursor: hand;
    align-self: center;
    user-select: none;
    transition: all 400ms ease 0s;
    display: flex;
  }

  .google-btn .google-icon-wrapper {
    position: absolute;
    margin-top: 1px;
    margin-left: 1px;
    width: 40px;
    height: 40px;
    border-radius: 2px;
    user-select: none;
  }

  .google-btn .google-icon-svg {
    position: absolute;
    margin-top: 11px;
    margin-left: 11px;
    width: 18px;
    height: 18px;
    user-select: none;
  }

  .google-btn .btn-text {
    float: right;
    margin: 11px 14px 40px 40px;
    color: #757575;
    font-size: 14px;
    letter-spacing: 0.2px;
    font-family: "Source Sans Pro", sans-serif;
    user-select: none;
  }

  .google-btn:hover {
    box-shadow: 0 3px 8px rgba(117, 117, 117, 0.5);
    user-select: none;
  }

  .google-btn:active {
    box-shadow: 0 1px 1px #757575;
    background: #f8f8f8;
    color: #ffffff;
    user-select: none;
  }
</style>
